var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVatepayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 37,
    viewBox: "0 0 45 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.3929 0.812256H1.60714C0.718192 0.812256 0 1.53045 0 2.4194V34.5623C0 35.4512 0.718192 36.1694 1.60714 36.1694H43.3929C44.2818 36.1694 45 35.4512 45 34.5623V2.4194C45 1.53045 44.2818 0.812256 43.3929 0.812256ZM3.61607 4.42833H41.3839V10.4551H3.61607V4.42833ZM41.3839 32.5533H3.61607V14.8748H41.3839V32.5533ZM29.481 29.339H37.7679C37.9888 29.339 38.1696 29.1582 38.1696 28.9373V25.3212C38.1696 25.1002 37.9888 24.9194 37.7679 24.9194H29.481C29.26 24.9194 29.0792 25.1002 29.0792 25.3212V28.9373C29.0792 29.1582 29.26 29.339 29.481 29.339Z",
    fill: "#5CBF14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVatepayIcon);
export default __webpack_public_path__ + "static/media/vatepay-icon.cd3e22ee8808651c4908128be7d50fa0.svg";
export { ForwardRef as ReactComponent };